import { render, staticRenderFns } from "./Pontualidade.vue?vue&type=template&id=422ac641&scoped=true&lang=pug&"
import script from "./Pontualidade.vue?vue&type=script&lang=js&"
export * from "./Pontualidade.vue?vue&type=script&lang=js&"
import style0 from "./Pontualidade.styl?vue&type=style&index=0&id=422ac641&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422ac641",
  null
  
)

export default component.exports